export const Direction = {
    ascending: 'asc',
    descending: 'desc',
};
